import type { TeaserBaseProps, TeaserMediaProps } from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Content, Media } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

interface TeaserCounterProps extends TeaserBaseProps, TeaserMediaProps {
  areaType?: 'main' | 'bauta'
  counterText: string
  counterNumber: number
  subtitle?: string
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-onsite](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-counter)
 * - Storybook: [TeaserCounter](https://designsystem.dn.se/?path=/docs/section-teaser-counter--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-counter/teaser-counter.scss'`
 */
export const TeaserCounter = ({
  areaType,
  targetLink,
  classNames,
  attributes,
  media,
  counterText,
  counterNumber,
  title,
  subtitle,
}: TeaserCounterProps) => {
  const componentClassName = 'ds-teaser--counter'
  const classes = formatClassString([componentClassName, classNames])

  const counterNumberIsValid = counterNumber !== undefined && counterNumber !== null

  return (
    <TeaserCard areaType={areaType} targetLink={targetLink} classNames={classes} attributes={attributes}>
      <Content>
        {title && (
          <h2 className={`${componentClassName}__title`}>
            <span className={`${componentClassName}__title--highlighted`}>{title}</span>
            {subtitle && ` – ${subtitle}`}
          </h2>
        )}

        {(counterNumberIsValid || counterText) && (
          <div className={`${componentClassName}__counter-wrapper`}>
            {counterNumberIsValid && (
              <ul className={`${componentClassName}__list`}>
                {counterNumber
                  .toString()
                  .split('')
                  .map((digit, index) => (
                    <li key={index} className={`${componentClassName}__item`}>
                      {digit}
                    </li>
                  ))}
              </ul>
            )}

            {counterText && (
              <p
                className={`${componentClassName}__counter-text`}
                dangerouslySetInnerHTML={{ __html: counterText }}
              ></p>
            )}
          </div>
        )}
      </Content>
      <Media media={media} />
    </TeaserCard>
  )
}
